/* 轻量操作cookie */
export function addCookie(name, value, domain, path, expireMinutes) {
  var val = value;

  if (value.indexOf(';') !== -1) {
    val = escape(value);
  }

  var cookieString = "".concat(name, "=").concat(val);

  if (domain) {
    cookieString += "; domain=".concat(domain);
  }

  if (path) {
    cookieString += "; path=".concat(path);
  } // 判断是否设置过期时间


  if (expireMinutes > 0) {
    var date = new Date();
    date.setTime(date.getTime() + expireMinutes * 60 * 1000);
    cookieString += ";expires=".concat(date.toGMTString());
  }

  if (typeof window !== 'undefined') {
    document.cookie = cookieString;
  }
}
export function getCookie(name) {
  if (typeof window !== 'undefined') {
    var results = document.cookie.match("(^|;) ?".concat(name, "=([^;]*)(;|$)"));

    if (results) {
      return unescape(results[2]);
    }

    return null;
  }

  return null;
}